import { Search2Icon } from "@chakra-ui/icons"
import {
  Box,
  Input,
  InputGroup,
  InputLeftElement,
  InputProps,
} from "@chakra-ui/react"

const SearchInput = (props: InputProps) => {
  return (
    <Box>
      <InputGroup minW={"260px"}>
        <InputLeftElement>
          <Search2Icon color='rgba(0,0,0,0.54)' />
        </InputLeftElement>
        <Input
          placeholder='Search...'
          type='search'
          {...props}
          border='1px solid #EEE'
          borderRadius='20px'
        />
      </InputGroup>
    </Box>
  )
}
export default SearchInput
